import { Badge as MuiBadge, Stack, styled } from '@mui/material'
import { ReactNode } from 'react'
import { WorkspaceAvatar } from '../workspace-avatar/workspace-avatar'
import { AvatarSize } from '../avatar-base/types'

export function WorkspaceAvatarBadge({
  children,
  workspaceId,
  showWorkspaceBadge,
}: {
  children: ReactNode
  workspaceId?: string
  showWorkspaceBadge?: boolean
}) {
  return (
    <Badge
      overlap="circular"
      invisible={!workspaceId || !showWorkspaceBadge}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      badgeContent={
        <BadgeContainer>
          <WorkspaceAvatar
            size={AvatarSize._4XS}
            workspaceId={workspaceId || ''}
            squareMode
            hasBorder={false}
          />
        </BadgeContainer>
      }
    >
      {children}
    </Badge>
  )
}

const Badge = styled(MuiBadge)`
  &.MuiBadge-root {
    width: fit-content;
    height: fit-content;
    padding: 0;
  }
`
const BadgeContainer = styled(Stack)`
  width: 22px;
  height: 22px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  border: 2px solid ${({ theme }) => theme.palette.primary50};
`
